// Shared "scroll back to the top" behaviour for views that show
// error / warning / success messages above their form.
//
// The app shell pins the component root to the viewport height
// (see `div:has(> .placeholder)` in public/style.css) and lets
// `.placeholder` scroll instead. The document itself never overflows,
// so `window.scrollTo` is a no-op inside these views. This finds
// whichever element is actually scrollable and scrolls that.

function isScrollable(el) {
  if (!el) {
    return false;
  }
  const overflowY = window.getComputedStyle(el).overflowY;
  if (overflowY !== "auto" && overflowY !== "scroll") {
    return false;
  }
  return el.scrollHeight > el.clientHeight;
}

function findScrollContainer(root) {
  if (!root || typeof root.querySelector !== "function") {
    return null;
  }

  // The scrolling shell normally sits inside the component.
  const shell = root.matches(".placeholder")
    ? root
    : root.querySelector(".placeholder");
  if (isScrollable(shell)) {
    return shell;
  }

  // Otherwise fall back to the nearest scrollable ancestor.
  let node = root.parentElement;
  while (node && node !== document.body && node !== document.documentElement) {
    if (isScrollable(node)) {
      return node;
    }
    node = node.parentElement;
  }

  return null;
}

export default {
  methods: {
    scrollToTop() {
      // Wait for the messages to render so the container has its final height.
      this.$nextTick(() => {
        const target = findScrollContainer(this.$el);
        if (target) {
          target.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          return;
        }
        // No scrollable shell (e.g. layout changed): scroll the page itself.
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      });
    },
  },
};
